<script setup>
import { inject, ref, computed, watch } from 'vue';
import Dropdown from 'primevue/dropdown';

const typesDonneePrimitifs = inject('typesDonneePrimitifs');
const typesDonneeObjets = inject('typesDonneeObjets');
const typesDonneeListesValeurs = inject('typesDonneeListesValeurs');

const { typeDonnee, proposerTypesObjets, desactive } = defineProps({
    typeDonnee: Object,
    proposerTypesObjets: Boolean,
    desactive: Boolean
});

const emit = defineEmits(['update:typeDonnee', 'modification']);

const typeDonneeSelectionne = ref(typeDonnee);

const typesDonneeParType = computed(() => {
    var typesDonneeParType = [
        {
            libelleGroupe: 'Types primitifs',
            typesDonnee: typesDonneePrimitifs
        }
    ];
    if (typesDonneeListesValeurs.value.length > 0) {
        typesDonneeParType.push({
            libelleGroupe: 'Listes de valeurs',
            typesDonnee: typesDonneeListesValeurs.value
        });
    }
    if (proposerTypesObjets && typesDonneeObjets.value.length > 0) {
        typesDonneeParType.push({
            libelleGroupe: 'Types d\'objet',
            typesDonnee: typesDonneeObjets.value
        });
    }
    return typesDonneeParType;
});

watch(() => typeDonnee, (t) => {
    typeDonneeSelectionne.value = t;
});

function modifierTypeDonnee(t) {
    emit('update:typeDonnee', t);
    if (t && t !== typeDonnee) {
        emit('modification', t);
    }
}

</script>

<template>
    <Dropdown 
      v-model="typeDonneeSelectionne" 
      :options="typesDonneeParType" 
      optionLabel="libelle"
      optionGroupLabel="libelleGroupe" 
      optionGroupChildren="typesDonnee" 
      :disabled="desactive"
      placeholder="Indéfini"
      @change="modifierTypeDonnee($event.value)"/>
</template>

<style scoped>

</style>